// @flow
import type { PddGroup } from '../types';
import CommonApi from './../commonApi';

const pddGroup = new CommonApi<PddGroup>('pddGroup', 'Темы ПДД');

export default {
  ...pddGroup
};
